import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { Utils } from '../../../../../common/js/Utils';
import { AccountCenterService as CommonAccountCenterService } from '../../../services/account-center/account-center.service';
import type { CoverpathPolicy } from '../../../../classes/coverpath_subclasses/CoverpathPolicy';
import { AgentAmorphicService } from '../../../../../coverpath-agent/public/js/services/amorphic/amorphic.service';
import { CoverpathControllerInterface } from '../../../interfaces/controller/CoverpathControllerInterface';
import { CashValueQuote } from '../../../../../common/js/policyAdmin/PolicyAdminClient';
import { TooltipPositions } from '../../../../../coverpath-common/angular/components/shared/basic-tooltip/basic-tooltip.component';

@Component({
  moduleId: module.id,
  selector: 'cash-value',
  templateUrl: './cash-value.component.html',
})
export class CashValueComponent implements OnInit {
  @Input() policy: CoverpathPolicy;
  @Input() cashValueQuote: CashValueQuote;
  controller: CoverpathControllerInterface;

  @Input() forClient: boolean = false;
  hideCard: boolean = false;
  isLoading: boolean = true;
  netValue: string = '';
  netValueInt: string = '';
  guaranteedCashValue: string = '';
  cashValueFromPaidUpAdditions: string = '';
  unearnedPremium: string = '';

  dividend: string = '';
  grossCashValue: string = '';
  outstandingLoanInterest: string = '';
  loanEnabled: boolean = false;
  dividendEnabled: boolean = false;
  tooltipPositions = TooltipPositions;

  constructor(private commonAccountCenterService: CommonAccountCenterService, amorphicService: AgentAmorphicService) {
    this.controller = amorphicService.controller;
  }

  async ngOnInit() {
    try {
      if (!this.forClient) {
        this.cashValueQuote = await this.commonAccountCenterService.getCashValue(this.policy);
      }
      this.netValueInt = Utils.formatCurrency(this.cashValueQuote.netCashValue, 0);
      this.netValue = Utils.formatCurrency(this.cashValueQuote.netCashValue);
      this.guaranteedCashValue = Utils.formatCurrency(this.cashValueQuote.guaranteedCashValue);
      this.cashValueFromPaidUpAdditions = Utils.formatCurrency(this.cashValueQuote.PUAGuaranteedCashValue, 2, false);
      this.unearnedPremium = Utils.formatCurrency(this.cashValueQuote.unearnedPremium, 2, false);

      this.dividendEnabled =
        this.cashValueQuote.totalAccumulatedDividendValue !== null &&
        this.cashValueQuote.totalAccumulatedDividendValue !== 0;
      this.dividend = Utils.formatCurrency(this.cashValueQuote.totalAccumulatedDividendValue, 2, false);

      this.loanEnabled =
        this.cashValueQuote.totalOutstandingLoanAmount !== null && this.cashValueQuote.totalOutstandingLoanAmount !== 0;
      this.grossCashValue = Utils.formatCurrency(this.cashValueQuote.grossCashValue, 2, false);
      this.outstandingLoanInterest = Utils.formatCurrency(-this.cashValueQuote.totalOutstandingLoanAmount, 2, false);
    } catch (e) {
      this.hideCard = true;
    } finally {
      this.isLoading = false;
    }
  }
}
